import React from "react";
import "./NewsFeed.css";
import {
  CNBC18Link,
  MintLink,
  NewYorkTimesLink,
  TheIndianExpressLink,
  ToiLink,
  YsLink,
  imgArr,
  imgArrMobile,
} from "../../../utils/LinkNews";

function NewsFeed() {
  return (
    <div className="newsfeed_container">
      <div className="news_content">As seen on</div>
      <div className="newsfeed_block_animation">
        <div className="slider_block">
          <div className="slider_path">
            <div className="slider_image">
              <a href={MintLink} target="_blank" rel="noopener noreferrer">
                <img src={imgArr[0]} alt="Mint" loading="lazy" />
              </a>
            </div>
            <div className="slider_image">
              <a href={CNBC18Link} target="_blank" rel="noopener noreferrer">
                <img src={imgArr[1]} alt="CNBC 18" loading="lazy" />
              </a>
            </div>
            <div className="slider_image">
              <a
                href={TheIndianExpressLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={imgArr[2]} alt="Indian Express" loading="lazy" />
              </a>
            </div>
            <div className="slider_image">
              <a href={YsLink} target="_blank" rel="noopener noreferrer">
                <img src={imgArr[3]} alt="Ys" loading="lazy" />
              </a>
            </div>
            <div className="slider_image">
              <a
                href={NewYorkTimesLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={imgArr[4]} alt="Newyork Times" loading="lazy" />
              </a>
            </div>
            <div className="slider_image">
              <a href={ToiLink} target="_blank" rel="noopener noreferrer">
                <img src={imgArr[5]} alt="TOI" loading="lazy" />
              </a>
            </div>
            <div className="slider_image">
              <a href={MintLink} target="_blank" rel="noopener noreferrer">
                <img src={imgArr[0]} alt="Mint" loading="lazy" />
              </a>
            </div>
            <div className="slider_image">
              <a href={CNBC18Link} target="_blank" rel="noopener noreferrer">
                <img src={imgArr[1]} alt="CNBC 18" loading="lazy" />
              </a>
            </div>
            <div className="slider_image">
              <a
                href={TheIndianExpressLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={imgArr[2]} alt="Indian Express" loading="lazy" />
              </a>
            </div>
            <div className="slider_image">
              <a href={YsLink} target="_blank" rel="noopener noreferrer">
                <img src={imgArr[3]} alt="Ys" loading="lazy" />
              </a>
            </div>
            <div className="slider_image">
              <a
                href={NewYorkTimesLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={imgArr[4]} alt="Newyork Times" loading="lazy" />
              </a>
            </div>
            <div className="slider_image">
              <a href={ToiLink} target="_blank" rel="noopener noreferrer">
                <img src={imgArr[5]} alt="TOI" loading="lazy" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="newsfeed_block_animation_mobile">
        <div className="image-grid">
          <div className="slider-image-mobile">
            <a href={CNBC18Link} target="_blank" rel="noopener noreferrer">
              <img src={imgArrMobile[0]} alt="CNBC 18" loading="lazy" />
            </a>
          </div>
          <div className="slider-image-mobile">
            <a
              href={NewYorkTimesLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={imgArrMobile[1]} alt="Newyork Times" loading="lazy" />
            </a>
          </div>
          <div className="slider-image-mobile">
            <a href={ToiLink} target="_blank" rel="noopener noreferrer">
              <img src={imgArrMobile[2]} alt="TOI" loading="lazy" />
            </a>
          </div>
          <div className="slider-image-mobile">
            <a href={YsLink} target="_blank" rel="noopener noreferrer">
              <img src={imgArrMobile[3]} alt="Ys" loading="lazy" />
            </a>
          </div>
          <div className="slider-image-mobile">
            <a href={MintLink} target="_blank" rel="noopener noreferrer">
              <img src={imgArrMobile[4]} alt="Mint" loading="lazy" />
            </a>
          </div>
          <div className="slider-image-mobile">
            <a
              href={TheIndianExpressLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={imgArrMobile[5]}
                alt="The Indian Express"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsFeed;
